import { Expense, UserExpense } from '@models';

export interface ExpenseState {
  expenses: Expense[];
  userExpenses: { [userId: string]: UserExpense[] };
  fetchedAt: Date | null;
}

export const initialExpenseState: ExpenseState = {
  expenses: [],
  userExpenses: {},
  fetchedAt: null,
};
